import React, {useState} from 'react';
import {Grid, Card, CardActionArea, CardContent, CardMedia, Divider } from '@material-ui/core/';
import {useStyles} from './style';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

import ModalImage from 'components/ImageModal';
// import SubirFotoCiudadano from './subirFoto';
// import { functions } from 'constants/index';

function DatosDeIdentidadCiudadano(props) {
    const classes = useStyles(),
    [verImagen, setVerImagen] = useState(false),
    // [validations, setValidations] = useState({ isError: false, errorMessages: "La foto del ciudadano es requerida"}),
    [datosImagen, setDatosImagen] = useState({image:'', title:'',});

    const VerImagen =(datosImagen)=>{
        setDatosImagen({image: datosImagen.foto, title: datosImagen.tipo})
        setVerImagen(true)
    }
    const CerrarVerImagen =()=>{
        setVerImagen(false)
    }

    // const addCitizenPhoto = (e) => {
    //     setValidations({  isError: false, errorMessages: ""})

    //     if(e.target.files.length === 0 ) {
    //         return cleanValidations("La foto del ciudadano es requerida")
    //     }

    //     if(!functions.validateFileType(e.target.files[0], ".png, .jpg, .jpeg")) {
    //         return cleanValidations("Solo de aceptan documentos con extension .png, .jpg, .jpeg")
    //     }

    //     if(functions.validateFileSize(e.target.files[0], "10 MB")) {
    //         const oneMegaInBytes = 1048576;
    //         return cleanValidations( `Su archivo pesa ${(e.target.files[0].size / oneMegaInBytes).toFixed(2)} MB y solo se aceptan archivos de 10 MB`)
    //     }

    //     const reader = new FileReader();
    //     reader.onload = () =>{
    //       if(reader.readyState === 2){
    //             props.SET_PROFILE_IMG({profileImg: reader.result})
    //       }
    //     }

    //     if(e.target.files.length > 0 ) {
    //         props.SET_DATA_IDENTIDAD_FOTOS_VACIA(false);
    //         reader.readAsDataURL(e.target.files[0])
    //     }
    // }

    // const cleanValidations = (errorMessages) => {
    //     props.SET_DATA_IDENTIDAD_FOTOS_VACIA(true);
    //     props.CLEAR_PROFILE_IMG({profileImg: ""});
    //     return setValidations({  isError: true, errorMessages});
    // }


return (
    <div>
       {/* { props.datosIdentidadFoto.fotosVieneVacio && props.datosIdentidad.length == 0 &&
            <SubirFotoCiudadano
                validators={{required: true, size: "5 MB",}}
                accept=".png, .jpg, .jpeg" name="FotoCiudadano"
                onChange={addCitizenPhoto}
                label={"Adjuntar la foto de medio cuerpo del ciudadano"}
                id="fotoCiudadano"
                profileImg={props.datoIdentidadFotoIngresada}
                alt="Foto del ciudadano"
                isError={validations.isError}
                errorMessages ={validations.errorMessages}
            />
        }  */}
        { props.datosIdentidadFoto.fotosVieneVacio && (
            <Grid item xs={12}>
                <div className={classes.centerText}><strong>No hay FOTO, FIRMA Y HUELLA para mostrar</strong> </div>
            </Grid >
        )}
{/*
       { !props.datosIdentidadFoto.fotosVieneVacio && props.datoIdentidadFotoIngresada && props.datosIdentidad.length == 0 ?  
            <SubirFotoCiudadano
                validators={{required: true, size: "5 MB",}}
                accept=".png, .jpg, .jpeg" name="FotoCiudadano"
                onChange={addCitizenPhoto}
                label={"Adjuntar la foto de medio cuerpo del ciudadano"}
                id="fotoCiudadano"
                profileImg={props.datoIdentidadFotoIngresada}
                alt="Foto del ciudadano"
                isError={validations.isError}
                errorMessages ={validations.errorMessages}
            />: ""
        }  */}
        <Grid container className={classes.rootGrid} justify="center" >
            {props.datosIdentidad.map((value, index) => (
            <Grid key={index} item>
                <Card className={classes.rootCard}>
                    <CardActionArea>
                        <div className={classes.contentMedia}>
                            <CardMedia
                                className={classes.media}
                                alt="image"
                                image={value.foto}
                                title="image"
                                onClick={()=>VerImagen(value)}
                            />
                        </div>
                        <CardContent  className={classes.cardContent}>
                        <Grid item xs={12}>
                            <div className={classes.centerTitle}><Divider /> <strong>{value.tipo}</strong> <Divider /></div>
                        </Grid >
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            ))}
            <ModalImage base64={datosImagen.image} title={datosImagen.title} open={verImagen} handleClose={CerrarVerImagen}/>
            <div >
            </div>
        </Grid>
    </div>
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(DatosDeIdentidadCiudadano);